// Module
var code = `<div class="{{.investingButtonStyle}}"
     style="{{#.zIndex}}z-index:{{.zIndex}};{{/}}"
     on-click='@this.private_MouseClick(event)'
     on-mouseover="@this.private_MouseOver(event)"
     on-mouseleave="@this.private_MouseLeave(event)"
     {{^.enabled}}disabled="" {{/}}
     {{#if .focused}}focused{{/if}}
     {{#if .canCheck}}{{#.checked}}checked{{/}}{{/if}}
     as-tooltip="tooltip"
     style="{{>visibility}}{{#.width}}width:{{.width}}px;{{/}}
    {{#.height}}height:{{.height}}px;{{/}}">

    {{#if .isColoringButton}}
    <div class="coloringButton-container" style="background:url({{.coloringButtonImage}}) center center no-repeat transparent;">
        <div style="background-color:{{.coloringButtonColor}};">{{.BackText}}</div>
    </div>
    {{/if}}

    {{#if .image}}
    <span class="js-button-img" as-tooltip="tooltip"
          style="background:url({{ .enabled && .canCheck && .checked && .imageChecked ? .imageChecked : .image }}) center center no-repeat;">
    </span>
    {{/if}}

    {{#if .SVG}}
    <svg>
        <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{.name}}"></use>
    </svg>
    {{/if}}

    {{#if .text}}
    <div class="js-text"  as-tooltip="tooltip">{{.text}}</div>
    {{/if}}

    {{^.enabled}}<div class="js-disabled-icon"></div>{{/}}
</div>`;
// Exports
export default code;